export function sleep(second: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, 1000 * second);
  });
}
